import angular from 'angular';
import { NodeService } from './model/node-service';

const nodeService = /* @ngInject */ (
	/** @type {import('angular').auto.IInjectorService} */ $injector,
) => new NodeService($injector);

/**
 * @ngdoc service
 * @name app.Node
 * @description
 * # Node
 * Service in the app.
 */
export default angular.module('app')
	.factory('NodeService', nodeService);
